import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import AdNav from "../components/adNav";
import Time from "../components/time";

const FlashNewsEntry = () => {
  const [formData, setFormData] = useState({ heading: "", desc: "", expiryDate: "", content: ""});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

      if (!formData.heading.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Empty Field',
        text: 'Please Enter FlashNews Heading!',
      });
      return;
    }

    if (!formData.desc.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Empty Field',
        text: 'Please Enter FlashNews Short Description!',
      });
      return;
    }

     if (!formData.expiryDate.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Empty Field',
        text: 'Please Select Expiry Date!',
      });
      return;
    }

     if (!formData.content.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Empty Field',
        text: 'Please Enter Flash News Content!',
      });
      return;
    }

    const payload = {
        message: formData.content,
        desc: formData.desc,
        heading: formData.heading,
        expiryDate : formData.expiryDate,
    };

    console.log(payload);
    

    try {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      await axios.post("https://rfs2.infraconsoft.net.in/api/flashNews_insert", payload);

      Swal.fire("Success", "Flash News added successfully", "success");
      navigate("/admin/flashnewslist");
    } catch (error) {
      Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
  };

  return (
    <div id="admin-container">
      <AdNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Flash News Entry</h2>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Enter the Headline:</label>
                <input type="text" name="heading" value={formData.heading} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Enter Short Description:</label>
                <input type="text" name="desc" value={formData.desc} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Current Date:</label>
                <input type="date" value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
              <div className="form-group">
                <label>Expiry Date:</label>
                <input type="date" name="expiryDate" value={formData.expiryDate} onChange={handleChange} />
              </div>
            </div>

            <div className="form-group">
  <label>Flash News Content:</label>
  <textarea
    name="content"
    value={formData.content}
    onChange={handleChange}
    rows="5"
    style={{ width: "100%", padding: "10px" }}
  ></textarea>
</div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FlashNewsEntry;
